import { FormEnginePlugin } from '@form-engine/core-application';
import { Server } from '@form-engine/bso-cxp-attachments-client/dist';
import Element, { apiName } from './components/attachments-element';
import BsoAttachmentValidation from './validations/attachment-validation';
import * as translations from './core-translations';
import BsoAttachmentListValidation from './validations/attachment-list-validation';

declare module '@form-engine/core-application/types/form' {
    interface ElementDefinitionSubType {
        [apiName]: ElementDefinitionBoundsProps &
            ElementDefinitionFieldProps &
            ElementDefinitionValidationProps & {
                multiple?: boolean;
                renderAsList?: boolean;
                listSettings?: {
                    bsoCategory?: string;
                    accept?: string;
                    validationMaxAttachmentSize?: string;
                    validationMaxAttachments?: string;
                    required?: boolean;
                }[];
                accept?: string;
                bsoServer?: Server;
                validationMaxFileSize?: string;
                validationMinLength?: string;
                validationMaxLength?: string;
            };
    }
}

export default {
    elements: {
        [apiName]: Element,
    },
    validations: {
        BsoAttachmentValidation,
        BsoAttachmentListValidation,
    },
    translations,
} as FormEnginePlugin;
